export const hlr = {
  name: 'hlr',
  title: 'hlr.breadcrumb.title',
  icon: () => import('@shared/components/icon/sidebar/icon-hlr.vue'),
  route: { name: 'hlr.index' },
  children: [
    {
      title: 'hlr.breadcrumb.requests.index',
      route: { name: 'hlr.requests.index' }
    }
  ]
};
